/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { arrayOf, date, DateFormat, entity, enumeration, subentity } from '@gh/core-data';
import { ContactDeliveryMethodIntMapper } from '../../contacts';
import { LetterMapper } from '../../letters';
import {
  JobChangeOrderDetailsDto,
  JobChangeOrderDetailsMainDto,
  JobChangeOrderDetailsPreviewDto,
  JobChangeOrderDetailsSaveDto,
  JobChangeOrderDetailsSaveResponseDto,
  JobChangeOrderDrawStageDto,
  JobChangeOrderDto,
  JobChangeOrderListDto,
  JobChangeOrderListItemDto,
  JobChangeOrderListMasterInfoDto,
  JobChangeOrderTabListDto,
  JobChangeOrderTabListTotalDto,
  JobVariationStatus,
} from './job-change-order.dto';

export const JobChangeOrderListMapper = entity<JobChangeOrderListDto>({
  job: subentity<JobChangeOrderListMasterInfoDto>({}),
  changeOrders: arrayOf(subentity<JobChangeOrderListItemDto>({
    dateCreated: date(DateFormat.DateTime),
    status: enumeration(JobVariationStatus),
  })),
});

export const JobChangeOrderMapper = entity<JobChangeOrderDto>({
  dateCreated: date(DateFormat.DateTime),
  status: enumeration(JobVariationStatus),
});

export const JobVariationTotalMapper = entity<JobChangeOrderTabListTotalDto>({
  status: enumeration(JobVariationStatus),
});

export const JobChangeOrderTabListMapper = entity<JobChangeOrderTabListDto>({
  variations: arrayOf(JobChangeOrderMapper),
  totals: arrayOf(JobVariationTotalMapper),
});

export const JobChangeOrderDetailsMainMapper = entity<JobChangeOrderDetailsMainDto>({
  status: enumeration(JobVariationStatus),
  addedDate: date(DateFormat.DateTime),
  producedDate: date(DateFormat.DateTime),
  deliveryBy: ContactDeliveryMethodIntMapper,
  invoiceDate: date(DateFormat.Date),
});

export const JobChangeOrderDetailsMapper = entity<JobChangeOrderDetailsDto>({
  changeOrder: JobChangeOrderDetailsMainMapper,
  drawStages: arrayOf(subentity<JobChangeOrderDrawStageDto>({
    accountingDate: date(DateFormat.DateTime),
  })),
});

export const JobChangeOrderDetailsSaveMapper = entity<JobChangeOrderDetailsSaveDto>({
  jobChangeOrder: JobChangeOrderDetailsMainMapper,
});

export const JobChangeOrderDetailsPreviewMapper = entity<JobChangeOrderDetailsPreviewDto>({
  jobChangeOrder: JobChangeOrderDetailsMainMapper,
});

export const JobChangeOrderDetailsSaveResponseMapper = entity<JobChangeOrderDetailsSaveResponseDto>({
  jobChangeOrder: JobChangeOrderDetailsMainMapper,
  letterTemplate: LetterMapper,
});
